import React from 'react';

import {
  SkeletonBody,
  SkeletonButton,
  SkeletonImage,
  SkeletonHeadline,
} from '@xingternal/skeleton';

import styles from './KununuSkeleton.css';

const KununuSkeleton = () => (
  <>
    <div className={styles.ratingWrapper}>
      <RatingBox />
      <RatingBox />
      <div className={styles.ratingMain}>
        <div className={styles.ratingMainText}>
          <SkeletonBody variant="primary" />
        </div>
        <SkeletonButton
          variant="primary"
          size="small"
          className={styles.ratingMainButton}
        />
      </div>
    </div>
    <div className={styles.reviewsWrapper}>
      <KununuSubHeader />
      <div className={styles.carouselWrapper}>
        <Card />
        <Card />
        <Card />
      </div>
    </div>
    <div className={styles.benefitsWrapper}>
      <KununuSubHeader />
      <div className={styles.tagWrapper}>
        {[...Array(5)].map((_, index) => (
          <SkeletonImage
            key={index}
            size="small"
            variant="primary"
            className={styles.tag}
          />
        ))}
      </div>
    </div>
  </>
);

const RatingBox = () => (
  <div className={styles.ratingbox}>
    <SkeletonHeadline variant="primary" size="medium" amountRows={1} />
    <SkeletonBody
      variant="primary"
      amountRows={2}
      className={styles.ratingboxBody}
    />
  </div>
);

const KununuSubHeader = () => (
  <div className={styles.kununuSubHeader}>
    <SkeletonHeadline
      variant="primary"
      size="small"
      className={styles.headerHeadline}
      amountRows={1}
    />
  </div>
);

const Card = () => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <SkeletonBody
        variant="primary"
        className={styles.cardHeaderLeft}
        amountRows={1}
      />
      <SkeletonBody
        variant="primary"
        className={styles.cardHeaderRight}
        amountRows={1}
      />
    </div>
    <SkeletonBody
      variant="primary"
      className={styles.cardBody}
      amountRows={3}
    />
    <SkeletonBody
      variant="primary"
      className={styles.cardFooter}
      amountRows={1}
    />
  </div>
);

export default KununuSkeleton;
